



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NavType from "./Type/NavType";
import ProgressInfoFomatter from "./Type/ProgressInfoFomatter";
//utils
import Utils from "../utils/utils";
@Component
export default class Progress extends Utils {
  @Prop()
  public componentProgressInfo!: ProgressInfoFomatter;
  @Prop()
  public showDialog!: boolean;
  private currentNav: number = 0;
  private navLink: NavType[] = [
    { name: "首页", router: "/home" },
    { name: "下载", router: "/download" }
  ];
  private close() {
    this.$emit("changeCurrentDownloadStatus");
    this.$emit("update:showDialog", false);
  }
}
